import React from 'react';
import '../styles/Lots.css'
import LotCard from '../components/LotCard';
import cangrejologo from '../assets/Cangrejos/logo.jpg'
import cangrejolots from '../assets/Cangrejos/lots.jpg'
import cangrejomain from '../assets/Cangrejos/main.jpg'
import pinueloslogo from '../assets/Pinuelos/logo.jpg'
import pinueloslots from  '../assets/Pinuelos/lots.jpg'
import pinuelomain from '../assets/Pinuelos/main.jpg'
import vistalogo from '../assets/Vista/logo.jpg'
import vistalots from '../assets/Vista/lots.jpg'
import vistamain from '../assets/Vista/main.jpg'
import manglareslogo from '../assets/Manglares/logo.jpg'
import manglareslots from '../assets/Manglares/lots.jpg'
import manglaresmain from '../assets/Manglares/main.jpg'
import palmaritomap from '../assets/Maps/LotsMaps/palmarito.jpg'
import puertecitomap from '../assets/Maps/LotsMaps/puertecito.jpg'


const translations = {
  en: {
    cangrejosDesc: "Second phase offers 33 new lots, following the successful sale of 40+ in phase one, just 5 minutes from Playa Palmarito and 15 minutes from Puerto Escondido. These lots, with water and electricity, are near El Origen and Vivo Resorts, and have a private entrance, perfect for building your coastal home.",
    pinuelosDesc: "Premium lots near Palmarito beach, in a rapidly developing area of Puerto Escondido. Just moments from El Origen Beach Club, Vivo Resorts, and a short drive to Bajos de Chila and the airport, these 300 square meter lots provide an ideal investment. Residents enjoy a private clubhouse with a pool, BBQ, bar, and terrace, blending luxury living with the natural beauty of the Oaxacan coast. Invest in Piñuelos Residencial and embrace a vibrant coastal lifestyle.",
    vistaDesc: "Vista Verde Residencial offers 58 lots with stunning river and some ocean views, just 1.2 km from the beach. Nestled in a natural setting, A promising investment area with excellent views and proximity to the coast. Secure your prime location before prices rise.",
    manglaresDesc: "Manglares Residencial offers 70+ lots in Oaxaca, blending nature with coastal living. Surrounded by mangroves, enjoy mountain and ocean views, with provided utilities. Just 2km from the beach, and 15 minutes from the airport, near El Origen and Vivo Resorts, a growing Puerto Escondido area.",
    cangrejosPrice: "List Price: $863,000 MXN-- You Pay: $620,000 MXN",
    pinuelosPrice: "List Price: $1,500,000 MXN-- You Pay: $990,000 MXN",
    vistaPrice: "List Price: $372,000 MXN-- You Pay: $267,000 MXN",
    manglaresPrice: "List Price: $500,000 MXN-- You Pay: $400,000 MXN",
    manglaresSize: "200 mt2 on average",
    cangrejosSize: "300 mt2 on average",
    pinuelosSize: "300 mt2 on average",
    vistaSize: "250 mt2 on average, but there are 200 mt2 lot available",
    disclaimer: "*Prices may vary depending on lots size mt2"

  },
  es: {
    cangrejosDesc: "Segunda fase ofrece 33 nuevos lotes, luego de la exitosa venta de 40+ en la primera fase, a solo 5 minutos de Playa Palmarito y 15 minutos de Puerto Escondido. Estos lotes con agua y electricidad, cerca de El Origen y Vivo Resorts, tienen entrada privada, perfectos para construir tu hogar costero.",
    pinuelosDesc: "Lotes premium cerca de la playa Palmarito, en una zona en rápido desarrollo de Puerto Escondido. A momentos del El Origen Beach Club, Vivo Resorts, y cerca del aeropuerto, estos lotes de 300 m² son una inversión ideal. Los residentes disfrutan de una clubhouse con piscina, BBQ, bar y terraza, combinando lujo con la belleza natural de la costa oaxaqueña. Invierte en Piñuelos Residencial y adopta un estilo de vida costero vibrante.",
    vistaDesc: "Vista Verde Residencial ofrece 58 lotes con vistas al río y parciales al mar, a 1.2 km de la playa. En un entorno natural, zona con gran potencial de inversión por sus vistas y proximidad a la costa. Asegura tu ubicación privilegiada antes de que suban los precios.",
    manglaresDesc: "Manglares Residencial ofrece más de 70 lotes en Oaxaca, combinando naturaleza y vida costera. Rodeado de manglares, disfruta de vistas a la montaña y al mar, con servicios incluidos. A solo 2km de la playa y 15 minutos del aeropuerto, cerca de El Origen y Vivo Resorts, en una zona en crecimiento de Puerto Escondido.",
    cangrejosPrice: "Precio de lista: $863,000 MXN-- Precio con Descuento: $620,000 MXN",
    pinuelosPrice: "Precio de lista: $1,500,000 MXN-- Precio con Descuento: $990,000 MXN",
    vistaPrice: "Precio de lista: $372,000 MXN-- Precio con Descuento: $267,000 MXN",
    manglaresPrice: "Precio de lista: $500,000 MXN-- Precio con Descuento: $400,000 MXN",
    manglaresSize: "200 mt2 en promedio",
    cangrejosSize: "300 mt2 en promedio",
    pinuelosSize: "300 mt2 en promedio",
    vistaSize: "250 mt2 en promedio, pero hay desde 200 mt2",
    disclaimer: "*Los precios pueden variar dependiendo del tamaño en mt2"
  }
};

const LotsGrid = ({ language }) => {
  const lotsData = [
    {
      id: 1,
      compoundLogo: cangrejologo,
      compoundMap: palmaritomap,
      compoundName: 'Cangrejos',
      mainImage: cangrejomain,
      mainMapImage: cangrejolots,
      lotsAvailable: 18,
      link: '/cangrejos',
      descriptionKey: 'cangrejosDesc',
      priceKey: 'cangrejosPrice',
      sizkeKey: 'cangrejosSize',
      disclaimer: 'disclaimer'
    },
    {
      id: 2,
      compoundLogo: pinueloslogo,
      compoundMap: palmaritomap,
      compoundName: 'Piñuelos',
      mainImage: pinuelomain,
      mainMapImage: pinueloslots,
      lotsAvailable: 15,
      link: '/pinuelos',
      descriptionKey: 'pinuelosDesc',
      priceKey: 'pinuelosPrice',
      sizkeKey: 'pinuelosSize',
      disclaimer: 'disclaimer'
    },
    {
      id: 3,
      compoundLogo: vistalogo,
      compoundMap: puertecitomap,
      compoundName: 'Vista Verda',
      mainImage: vistamain,
      mainMapImage: vistalots,
      lotsAvailable: 9,
      link: '/vista',
      descriptionKey: 'vistaDesc',
      priceKey: 'vistaPrice',
      sizkeKey: 'vistaSize',
      disclaimer: 'disclaimer'
    },
    {
      id: 4,
      compoundLogo: manglareslogo,
      compoundMap: palmaritomap,
      compoundName: 'Residencial Manglares',
      mainImage: manglaresmain,
      mainMapImage: manglareslots,
      lotsAvailable: 3,
      link: '/manglares',
      descriptionKey: 'manglaresDesc',
      priceKey: 'manglaresPrice',
      sizkeKey: 'manglaresSize',
      disclaimer: 'disclaimer'
    }
  ];

  return (
    <div className="lots-grid">
      {lotsData.map(lot => (
        <LotCard
          key={lot.id}
          compoundLogo={lot.compoundLogo}
          compoundMap={lot.compoundMap}
          compoundName={lot.compoundName}
          mainImage={lot.mainImage}
          mainMapImage={lot.mainMapImage}
          lotsAvailable={lot.lotsAvailable}
          link={lot.link}
          description={translations[language][lot.descriptionKey]}
          price={translations[language][lot.priceKey]} 
          size={translations[language][lot.sizkeKey]}
          disclaimer={translations[language][lot.disclaimer]}
        />
      ))}
    </div>
  );
};

export default LotsGrid;
  